import { render, staticRenderFns } from "./AppTitle.vue?vue&type=template&id=ec677368&scoped=true&lang=pug"
var script = {}
import style0 from "./AppTitle.vue?vue&type=style&index=0&id=ec677368&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec677368",
  null
  
)

export default component.exports